import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCocktail: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cocktail, drink"><path d="M2.75002 3C2.44678 3 2.17338 3.1826 2.05723 3.46271C1.94107 3.74282 2.00502 4.06532 2.21927 4.27991L11.25 13.325V20.5H7.77362C7.3594 20.5 7.02362 20.8358 7.02362 21.25C7.02362 21.6642 7.3594 22 7.77362 22H16.2745C16.6887 22 17.0245 21.6642 17.0245 21.25C17.0245 20.8358 16.6887 20.5 16.2745 20.5H12.75V13.325L21.7808 4.27991C21.995 4.06532 22.059 3.74282 21.9428 3.46271C21.8267 3.1826 21.5533 3 21.25 3H2.75002Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCocktail;
